import type { SVGProps } from 'react';

const VIEWBOX_SIZE = 32;
const ICONOIR_OPTICAL_SIZE = 24;

type CreateAgentIconProps = SVGProps<SVGSVGElement>;

/** Scale stroke to match Iconoir weight (24px optical size) in our 32px viewBox. */
export function getCreateAgentStrokeWidth(strokeWidth: number | string | undefined = 1.75) {
  const value = typeof strokeWidth === 'number' ? strokeWidth : Number.parseFloat(strokeWidth) || 1.75;
  return value * (VIEWBOX_SIZE / ICONOIR_OPTICAL_SIZE);
}

export function CreateAgentIcon({
  width = 20,
  height = 20,
  strokeWidth = 1.75,
  className,
  ...props
}: CreateAgentIconProps) {
  const scaledStroke = getCreateAgentStrokeWidth(strokeWidth);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M4 21.3333V10.6667C4 6.98477 6.98477 4 10.6667 4H21.3333C25.0152 4 28 6.98477 28 10.6667V21.3333C28 25.0152 25.0152 28 21.3333 28H10.6667C6.98477 28 4 25.0152 4 21.3333Z"
        stroke="currentColor"
        strokeWidth={scaledStroke}
      />
      <path
        d="M22 19.332C22 19.332 20 21.9987 16 21.9987C12 21.9987 10 19.332 10 19.332"
        stroke="currentColor"
        strokeWidth={scaledStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="11.3346" cy="12.6667" r="1.33335" stroke="currentColor" strokeWidth={scaledStroke} />
      <circle cx="20.6667" cy="12.6667" r="1.33335" stroke="currentColor" strokeWidth={scaledStroke} />
    </svg>
  );
}
